import * as types from './mutation-types'
import { allSettled } from '@/core/helpers/promise.helpers'
import { postQuartiles, postAligns, getQuartiles, getScoreGroups, getScoringModels, putScoringModel, postScoringModel } from '@/services/Scores'
import { servers } from '@/helpers'
import { Bus } from '@/bus'
import store from '@/store'

/**
 *  Boot tasks
 *
 * @param dispatch
 * @param rootGetters
 *
 * @returns {Promise<any>}
 */
export const boot = ({ dispatch, rootGetters }) => {
  const boot = rootGetters['auth/entitlements'].getAnyPassed({
    'fetchScoreGroups': { score: 'read' },
    'fetchQuartileLocations': { score: 'read' }
  }).map(action => dispatch(action)).map(allSettled)

  return Promise.all(boot)
}

export const changeThreshold = ({ commit }, settings) => {
  commit(types.CHANGE_THRESHOLD, settings)
}

export const clear = ({ commit }) => {
  commit(types.CLEAR)
}

export const uploadQuartiles = ({ commit }, payload) => {
  return postQuartiles(payload)
}

export const uploadQuartileAligns = ({ commit }, payload) => {
  return postAligns(payload)
}

export const retrieveQuartiles = ({ commit }, data) => {
  return getQuartiles(data)
}

export const fetchScoreGroups = ({ commit }) => {
  return getScoreGroups()
    .then((groups) => {
      commit(types.FETCH_GROUPS, groups)
      return groups
    })
    .catch(() => {
      if (servers[store.state.auth.server].placeholderScoreGroups) {
        return servers[store.state.auth.server].placeholderScoreGroups
      }
      Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve score groups' })
    })
}

export const fetchScoringModels = ({ commit }, data) => {
  return getScoringModels(data)
}

export const createScoringModel = ({ commit }, data) => {
  return postScoringModel(data)
}

export const updateScoringModel = ({ commit }, data) => {
  return putScoringModel(data)
}

export const fetchQuartileLocations = async ({ commit }) => {
  let primaryLocations = []
  let locations = []
  await getQuartiles().then((resp) => {
    for (let i = 0; i < resp['quartiles'].length; ++i) {
      let quartileLocation = resp['quartiles'][i]['location_name']

      if (quartileLocation !== 'Global' && !(primaryLocations.includes(quartileLocation))) {
        let locationName = resp['quartiles'][i]['location_name']
        primaryLocations.push(locationName)
      }
    }

    primaryLocations.sort()
    for (let i = 0; i < primaryLocations.length; ++i) {
      locations.push(primaryLocations[i])
    }

    commit(types.FETCH_QUARTILE_LOCATIONS, locations)
  })
    .catch(() => {
      if (servers[store.state.auth.server].placholderLocations) {
        commit(types.FETCH_QUARTILE_LOCATIONS, servers[store.state.auth.server].placholderLocations)
      }

      Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve assessment locations' })
    })
}

export default {
  boot,
  changeThreshold,
  clear,
  uploadQuartiles,
  retrieveQuartiles,
  fetchScoreGroups,
  fetchQuartileLocations,
  fetchScoringModels,
  createScoringModel,
  updateScoringModel,
  uploadQuartileAligns
}
